import { useLocation } from "react-router-dom";
import SecurityColumn from "components/Auth/SecurityColumn";
import { Col, ElementWrapper, Row } from "components/BaseComponents/Flex";
import { Container, PasswordRefresh, PasswordSms } from "components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { useMediaQuery } from "context/media/MediaContext";
import PasswordChange from "components/Auth/Password/PasswordChange";
import { useAppSelector } from "redux/hooks";

const PasswordScreen = () => {
  const { isMobile } = useMediaQuery();
  const location = useLocation();
  let fromEmpDetail: boolean = location?.state?.fromEmpDetail || false;
  let phoneNumberForSmsPass: string = location?.state?.phoneNumberForSmsPass;
  const { userOtp } = useAppSelector((state) => state.otp);

  return (
    <Container>
      <ElementWrapper
        minHeight={isMobile ? "calc(100vh - 118px)" : "calc(100vh - 137px)"}
        padding='48px 0 0 0'
        width='872px'
      >
        {(userOtp?.UserLevel === "1" || userOtp?.UserLevel === "3") &&
        !!phoneNumberForSmsPass.length ? (
          <PasswordSms agentPhonenumber={phoneNumberForSmsPass} />
        ) : !fromEmpDetail ? (
          <>
            <PasswordRefresh />

            <Row
              alignItems='flex-start'
              backgroundColor={DIGIPOSTHEME.colors.secondaryOffWhite}
              justifyContent='center'
              isResponsive
              noMargin
            >
              <Col>
                <ElementWrapper
                  margin={isMobile ? "0" : "80px 0 0 0"}
                  padding='0'
                  width='227px'
                >
                  <SecurityColumn passwordFieldIsOpen={false} />
                </ElementWrapper>
              </Col>
            </Row>
          </>
        ) : (
          <PasswordChange />
        )}
      </ElementWrapper>
    </Container>
  );
};

export default PasswordScreen;
